
import Vue from  'vue';

export default {

    /*props: {
        content: Object
    },

    data(){
    	return {
    		requestedUrl: { type: String, default: '' }
    	}
    },

    created(){
    	this.requestedUrl = this.$route.path;
    },

    destroy(){
        console.log('destroy');
    }*/

    mounted()
    {
        this.eventHub.$emit('page:loaded', this)
    }

}
